<template>
    <div class="account">
        <br />

        <div class="center">导入Excel</div>

        <br />

        <div class="center" style="color: red">日期时间标签+项目编号相同的导入会覆盖</div>

        <br />

   
        <div class="center">
            <el-upload
                ref="uploadFile"
                style="display: inline-block; margin-left: 10px; margin-right: 10px"
                :limit="1"
                action
                name="file"
                :auto-upload="true"
                list-type="picture"
                :show-file-list="false"
                :http-request="uploadFile"
                accept=".xlsx .xls"
            >
                <el-button size="small" plain :loading="loading"> 上 传 </el-button>
            </el-upload>
        </div>
    </div>
</template>
<script>
export default {
    inject: ['reload'],
    components: {
    },
    name: 'otherUpload',
    data() {
        return {
            loading: false,
            token: ''
        };
    },
    beforeMount() {},
    mounted() {
        this.token = this.$route.query.token;
    },
    watch: {
        $route(to, from) {
            this.token = this.$route.query.token;
            this.reload();
        }
    },
    methods: {
        uploadFile(param) {
            this.loading = true;
            var fileObj = param.file;
            let fileData = new FormData(); // FormData 对象
            fileData.append('file', fileObj); // 文件对象
            fileData.append('upload_token', this.token);

            this.$api['uploadOther'](fileData)
                .then((res) => {
                    this.$refs.uploadFile.clearFiles();
                    if (res.code == 0) {
                        this.$message({
                            message: res.data,
                            type: 'success'
                        });
                        this.reload();
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.$refs.uploadFile.clearFiles();
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
.center {
    text-align: center;
}
</style>